import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import times from 'lodash/times'
import BasicText from '../../../Theme/Fonts/BasicText'
import TopPerformerBig from '../HelperClass/TopPerformerBig'
import TopPerformerSmall from '../HelperClass/TopPerformerSmall'

export type TopPerformerProps = {
    /**
     * id of the player
     */
    id?: string
    /**
     * firstname of the player
     */
    firstname: string
    /**
     * lastname of the player
     */
    lastname: string
    /**
     * team of the player
     */
    team?: string
    /**
     * score of the player
     */
    value: string | number
    /**
     * unit of the performed score
     */
    unit: string
    /**
     * url of the player image
     */
    imageUrl?: string
    /**
     * specifies the type of the Image can be either default or flag
     */
    imageType?: 'DEFAULT' | 'FLAG'
    /** info about imageUrl for seo */
    alt?: string
    /**
     * action called when pressed
     * @TJS-type: function
     */
    onPress?: () => void
}

export type TopPerformerCardProps = {
    /**
     * action called when pressed on the header
     * @TJS-type function
     */
    onPressHeader?: () => void

    /**
     * action called when pressed on the performer
     * @TJS-type function
     */
    onPressPlayer?: (index: number) => void

    /**
     * array of players with their score (at least one entry needed)
     */
    performers: TopPerformerProps[]

    /**
     * title of this top performer card (will be used as a unit for the top performer card big, too)
     */
    title: string
}

const TopPerformerCard: FunctionComponent<TopPerformerCardProps> = ({
    onPressHeader,
    onPressPlayer,
    performers,
    title,
}) => {
    if (!performers.length) {
        return null
    }
    return (
        <Grid
            noExpand
            backgroundColor="tahitian-3"
            borderRadius={4}
            borderColor="tahitian-4"
            border={1}
            overflow="hidden"
        >
            <Touchable onPress={onPressHeader}>
                <Grid paddingY={4} paddingX={5} noExpand>
                    <BasicText
                        fontSize="FS16"
                        lineHeight="LH16"
                        bold
                        color="onyx"
                        numberOfLines={1}
                    >
                        {title}
                    </BasicText>
                </Grid>
            </Touchable>
            <Grid>
                {times(Math.min(performers.length, 3), index => {
                    const onPress = (): void => onPressPlayer && onPressPlayer(index)
                    const performer = performers[index]
                    const key = `performers_${title}_${index}`
                    if (index === 0) {
                        return <TopPerformerBig key={key} performer={performer} onPress={onPress} />
                    }
                    return <TopPerformerSmall key={key} performer={performer} onPress={onPress} />
                })}
            </Grid>
        </Grid>
    )
}

export default TopPerformerCard
